export default "__VITE_ASSET__Bnb1mnJ8__"